module.exports = __webpack_public_path__ + "img/dvojluzkovy_pokoj_1.5cee42e5.jpg";